import { occupationSchema } from '../occupationOptions';
import { rentAddressScehama } from './rentAddressSchema';

export const rentAddressOccupationSchema = rentAddressScehama.shape({
  occupation: occupationSchema,
});
